import { render, staticRenderFns } from "./smartCockpit.vue?vue&type=template&id=68153f64&scoped=true"
import script from "./smartCockpit.vue?vue&type=script&lang=js"
export * from "./smartCockpit.vue?vue&type=script&lang=js"
import style0 from "./smartCockpit.vue?vue&type=style&index=0&id=68153f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68153f64",
  null
  
)

export default component.exports